<template>  
 <div class="login">
  <div class="linhaFundo"></div>
  <div class="jumbotron col-lg-4" >
  <img src="../../src/assets/luandre.png" alt="">
  <h3> Bem-vindo ao FastRH</h3>
  <small class="label label-default" >Módulo Administrativo</small><br/><br/>
    <div class="container"> 
        <form>
            <div class="form-group text-left">
                <label for="Login">Login FastRH</label>
                <input type="email" class="form-control" id="Login" placeholder="Login" v-model=" login.Email ">
            </div>
            <div class="form-group text-left">
                <label for="Senha">Senha FastRH</label>
                <input type="password" class="form-control" id="Senha" placeholder="Senha" v-model=" login.Senha "  @keyup.enter="fazerLogin">
            </div> 
            <span class="label label-danger">{{login.Mensagem}}</span> <br/><br/>
            <button type="button" class="btn btn-primary col-lg-6 col-lg-offset-3" @click="fazerLogin">
            Acessar
            <i class="fa fa-sign-in" v-show="!loading"></i>
            <i class="fa fa-circle-o-notch fa-spin" v-show="loading"></i>
            </button>
        </form>
    </div>
  </div>
 </div>
</template>
<script>
export default {
  components: {
  },
  methods: {
    fazerLogin: function () {
      this.loading = true
      this.$http.post('account/acessar', this.login)
      .then(function (res) {
        this.login = res.body
        localStorage.setItem('Usuario', JSON.stringify(res.body))
        location.reload()
      })
      .catch(function (error) {
        this.loading = false
        this.login = error.body
      })
    }
  },
  props: ['auth'],
  data () {
    return {
      login: {},
      loading: false
    }
  }
}
</script>
<style scoped>
.login{
    width:100%;
    display:inline-block;
}
h3 {
    background:transparent;
    color:black !important;
    padding: 5px 0 5px 0;
}
.jumbotron{ 
    position:absolute;
    margin:0 0 0 30%;
    -webkit-box-shadow: 0px 20px 44px -4px rgba(163,163,163,1);
-moz-box-shadow: 0px 20px 44px -4px rgba(163,163,163,1);
box-shadow: 0px 20px 44px -4px rgba(163,163,163,1);
border-radius:0 !important;
    }
.linhaFundo {
  background:#013c63;
  width:100%;
  min-height:150px;
  height:150px;  
  margin-top:30px;
  float:left; 
}
</style>



// WEBPACK FOOTER //
// Login.vue?46ff282e